import { render, staticRenderFns } from "./SummaryInspector.vue?vue&type=template&id=6bf725db&"
import script from "./SummaryInspector.vue?vue&type=script&lang=js&"
export * from "./SummaryInspector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports